<template>
    <Breadcrumbs main="Form Layout" title="Two Factor" />
    <div class="container-fluid">
        <div class="row">
            <twofactorAuthentication />
            <div class="col-sm-12">
                <div class="card">
                    <div class="card-body email-verify">
                        <div class="row g-3">
                            <emailVerification />
                            <verificationCode />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const twofactorAuthentication = defineAsyncComponent(() => import("@/components/theme/forms/formlayout/twofactor/twofactorAuthentication.vue"))
const emailVerification = defineAsyncComponent(() => import("@/components/theme/forms/formlayout/twofactor/emailVerification.vue"))
const verificationCode = defineAsyncComponent(() => import("@/components/theme/forms/formlayout/twofactor/verificationCode.vue"))
</script>